import React from "react";
import styles from "./Footer.module.scss";

type Props = {
  companyName?: string;
  year?: number;
};

function Footer({ companyName = "RaRuBaJo", year = new Date().getFullYear() }: Props) {
  return (
    <footer className={styles.footer}>
      <span>
        Copyright © {year} <span className={styles.brand}>{companyName}</span>.
      </span>
      <span>All rights reserved.</span>
    </footer>
  );
}

export default Footer;
